import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestLoa } from "../../entity/EntityRequestLoa";

export class DtoRequestLoasPostReq extends EntityRequestLoa {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
